module.exports = __webpack_public_path__ + "media/music/jazzy_bass_2-df5f0119.mp3";